import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

import nmaps from '@/../lib/n-maps/VueNMaps.ts'

Vue.use(nmaps, {
  provider: 'leaflet',
  options: {
    tiles: 'carto-light',
  },
  center: [39.223577, 9.121169],
})


new Vue({
    router,
    vuetify,
    render: (h) => h(App),
}).$mount('#app')
